<template lang="pug">
.caseVideo
  .Video-box
    Form(:model="question")
      .Video-stem
        FormItem
          Input.input1(type='text',placeholder='视频名称',v-model='question.stem')
        iDelModel.ide(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
    Upload(ref="upload",:before-upload="handleUpload",
            v-model="question.image"
            :format="['mp4']"
            :max-size="512000"
            action="/" style="display:block;text-align:left")
            Button.button(style="float:left") + 上传文件
    div.div(v-if="file !== null",style="line-height:32px") 文件名称 : {{file.name}}
    div.div(v-if="question.answer",style="line-height:32px") 此视频已保存！({{question.answer}})
    //- Button(type="text" @click="upload",
    //-      :loading="loadingStatus") {{ loadingStatus ? '上传中' : '点击上传' }}
    div.explain 支持视频文件格式：.mp4
</template>

<script>
import iDelModel from "@/components/common/iDelModel";
export default {
  components: {
    iDelModel
  },
  props: ["data"],
  data() {
    return {
      list: "",
      file: null,
      loadingStatus: false,
      type: "上传",
      question: {
        // title: "",
        stem: "",
        image: this.file
      }
    };
  },
  methods: {
    handleUpload(file) {
      console.log(file);
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (["video/mp4"].indexOf(file.type) === -1) {
        this.$Message.error("请上传正确的视频格式");
        return false;
      }
      if (!isLt20M) {
        this.$Message.error("上传视频大小不能超过20MB哦!");
        return false;
      }
      this.file = file;
      this.$Message.success("上传成功!");
      return false;
    },
    delModel() {
      this.$emit("delModel");
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        this.question = this.data;
      }
      //   this.$emit("data1:data", this.question);
    });
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
<style lang="stylus">
.caseVideo
  .Video-box
    padding 24px
    width 100%
    margin 0 auto
    .button
      color #3a76d2
    .div
      width 100%
      height 32px
      background rgba(248, 249, 250, 1)
      text-align left
      padding-left 10px
    .explain
      width 561px
      height 24px
      font-size 12px
      font-family MicrosoftYaHeiUI
      color rgba(128, 128, 128, 0.5)
      line-height 24px
      text-align left
    .Video-stem
      position relative
      .ide
        margin-top -10px
      .input1
        width 80%
        float left
      .ivu-form-item-content
        // margin-right 300px
      .btns
        position absolute
        top -5px
        right 0px
        .ivu-icon
          color #3A76D2FF
          font-size 22px
          top 0
          margin-right 12px
          background #F2F5FAFF
          width 24px
          height 24px
          border-radius 4px
          text-align center
          line-height @height
          &:hover
            cursor pointer
</style>
